export enum PrinterOutputType {
	A4 = "A4",
	Zebra = "Zebra",
}
